import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/js/bootstrap.bundle.min";
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'select2/dist/js/select2.min.js';
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.scss";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthProvider } from "./contexts/AuthContext";
import { WishlistProvider } from "./contexts/WishlistContext";
import { CartProvider } from "./contexts/CartContext";
const root = ReactDOM.createRoot(document.getElementById("root"));
const logWebVitals = (metric) => {
  //console.log(metric); // Logs metrics in the console
};
root.render(
 
  <WishlistProvider>
  {/* <AuthProvider> */}
  <ToastContainer position="top-right" autoClose={3000} />
    <App />
  {/* </AuthProvider> */}
  </WishlistProvider>
  
);

reportWebVitals(logWebVitals);
